import { TextBody } from '@tkww/orion-web-ds-text';
import { useAtomValue } from 'jotai';
import React from 'react';
import { vendorAwardsAtom } from '../../jotai/storefront/awards-summary';
import { HofBadgePaths } from '../../pages/Storefront/components/award-single-item/badge-svg-paths';
import { AwardBadgeSvg } from '../award-badge-svg/AwardBadgeSvg';
import Styles from './HofAwardTile.scss';

const HOF_AWARD_DESCRIPTION =
	"Earned by winning 'Best of Weddings' four or more times.";

export const HofAwardTile = () => {
	const awards = useAtomValue(vendorAwardsAtom);
	const hasHof = awards.some((a) => a.type === 'HOF');

	if (!hasHof) return null;

	return (
		<div className={Styles.tile}>
			<div className={Styles.badge}>
				<AwardBadgeSvg label="Hall of Fame Award">
					<HofBadgePaths />
				</AwardBadgeSvg>
			</div>

			<div className={Styles.content}>
				<div className={Styles.title} data-testid="hof-award-badge">
					<TextBody bold>Hall of Fame</TextBody>
				</div>
				<div className={Styles.subtitle} data-testid="hof-award-description">
					<TextBody size="sm" color="subtle-dark">
						{HOF_AWARD_DESCRIPTION}
					</TextBody>
				</div>
			</div>
		</div>
	);
};
